import axios from "axios";
import { API_ADDRESS } from "../../constants/config";

export class ContractOverviewService {
  public fetchContractOverview = async (params) => {
    try {
      const { token } = params;
      const { data }: any = await axios.get(
        `${API_ADDRESS}/public/contract/info`
      );

      const { rise } = data;

      let overview;
      switch (token) {
        case "rise":
          overview = {
            name: "Rise",
            token: "rise",
            balance: rise.quarantined,
            created: "29/04/2020 22:48:48",
            consumptionRatio: {
              contracts: 0,
              user: 100,
            },
            audits: [
              {
                name: "Iosiro",
                link:
                  "https://iosiro.com/audits/centric-protocol-smart-contract-audit",
              },
            ],
          };

          break;
        case "cash":
          overview = {
            name: "Cash",
            token: "cash",
            balance: 0,
            created: "29/04/2020 22:48:48",
            consumptionRatio: {
              contracts: 0,
              user: 100,
            },
            audits: [
              {
                name: "Iosiro",
                link:
                  "https://iosiro.com/audits/centric-cash-smart-contract-audit",
              },
            ],
          };

          break;
        default:
          overview = null;
      }

      return {
        overview,
      };
    } catch (e) {
      console.log(e);
      throw Error(e.message);
    }
  };
}
